<template>
  <RequestWizardStep name="Whose Records"
    :complete="is3rdParty || isWithinLast4Years === false"
  >
    <ContentCard
      title="Great! Let's get some more information about your records request."
    >
      <div>
        <RadioButtons
          label="I am requesting Medicare beneficiary claims records for:"
          :options="[
            { label: 'Myself', value: false },
            { label: 'Someone Else', value: true }
          ]"
          v-model="is3rdParty"
        />
      </div>

      <div v-show-slide="is3rdParty === false"
        class="mt-3"
      >
        <div>
          <AlertMessage type="warning"
            :show="isWithinLast4Years === true"
            title="MyMedicare.gov Blue Button"
          >
            <p>Please note that you can access your Medicare claims information from within the
              past four years online by using Medicare's secure Blue Button website.
            </p>

            <a target="_blank"
              href="https://www.medicare.gov/"
            >Click here to access Blue Button</a>.
          </AlertMessage>

          <RadioButtons
            label="Please choose the appropriate timeframe:"
            :options="[
              { label: 'Records from within the past 4 years', value: true },
              { label: 'Records from more than 4 years ago', value: false }
            ]"
            v-model="isWithinLast4Years"
          />
        </div>
      </div>
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import RadioButtons from '@/components/formFields/RadioButtons';
import AlertMessage from '@/components/AlertMessage';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';
import { is3rdParty } from '../requestWizardState';

export default {
  setup: () => ({ is3rdParty }),

  components: {
    RadioButtons, AlertMessage, RequestWizardStep
  },

  props: {
    value: Boolean
  },

  data: () => ({
    isWithinLast4Years: null
  })
};
</script>
